import React, { Component } from "react";
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";

class AchievementPopup extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={

    }
	
}
 
componentDidMount(){
}

  render() {
	 return (
		<div className="booked_pop_content">
			<div className="achieve_container">
				<div className="close_purple" onClick={this.props.closeAchievementPopup}></div>
				<div className="achie_popup_title">Achievement</div>
				<div className="outAchPict">
					<div className={"unlockTr " + (this.props.openedAchievement['achieveDate'] != '' ? 'unlGolTrop' : '')}></div>
					<div className="achPopSub">{this.props.openedAchievement['value']} {this.props.openedAchievement['name']}</div>
				</div>
				{ this.props.openedAchievement['achieveDate'] != '' ?
					<div className="achPopInfo">
						<div className="achInfoL">Attend {this.props.openedAchievement['value']} {this.props.openedAchievement['name']} classes</div>
						<div className="achInfoR">Completed</div>
					</div>
					:
					<div className="achPopInfo">
						<div className="achInfoL">Attend {this.props.openedAchievement['achieveValue']} {this.props.openedAchievement['name']} classes</div>
						<div className="achInfoR">{this.props.openedAchievement['value']-this.props.openedAchievement['achieveValue']} to go!</div>
					</div>
				}
				<div className="achPopLine">
					{ this.props.openedAchievement['achieveDate'] != '' ?
						<div className="achPopInsideLine" style={{width: "100%"}}></div>
						:
						<div className="achPopInsideLine" style={{width: this.props.openedAchievement['achievePercent']+"%"}}></div>
					}
				</div>
				{ this.props.openedAchievement['achieveDate'] != '' ?
					<div className="achScore">{this.props.openedAchievement['value']}/{this.props.openedAchievement['value']}</div>
					:
					<div className="achScore">{this.props.openedAchievement['achieveValue']}/{this.props.openedAchievement['value']}</div>
				}
			</div>
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  }
)(AchievementPopup);